/***********************************************************************
 *                           cookie工具类                              *
 * ********************************************************************/

/**
 * 设置cookie
 * @param name cookie名称
 * @param value cookie值
 * @param iDay cookie的时间
 */
export function setCookie(name, value, iDay) {
  var oDate = new Date()
  oDate.setDate(oDate.getDate() + iDay)
  document.cookie = name + '=' + value + ';expires=' + oDate
}

/**
 * 获取cookie的值
 * @param cookieVal 参数是cookie中的key返回value
 * @type {string}
 */
export function getCookie(cookieVal) {
  var currentCookie = ''
  document.cookie.split(';').forEach(item => {
    if (String.trim(item.split('=')[0]) === cookieVal) {
      currentCookie = item.split('=')[1] || ''
    }
  })
  return currentCookie
}
/**
 * 删除cookie
 * @param name cookie名称
 */
export function removeCookie(name) {
  this.setCookie(name, 1, -1)
}
/**
 * 获取URL参数
 * @param url 地址
 * @returns 例：getUrlPrmt("http://www.baidu.com?id=1&nam=张三&uid=12345654321&type=1,2,3")，结果{id: "1", nam: "张三", uid: "12345654321", type: "1,2,3"}
 */
export function getUrlPrmt(url) {
  url = url ? url : window.location.href
  let _pa = url.substring(url.indexOf('?') + 1),
    _arrS = _pa.split('&'),
    _rs = {}
  for (let i = 0, _len = _arrS.length; i < _len; i++) {
    let pos = _arrS[i].indexOf('=')
    if (pos == -1) {
      continue
    }
    let name = _arrS[i].substring(0, pos),
      value = window.decodeURIComponent(_arrS[i].substring(pos + 1))
    _rs[name] = value
  }
  return _rs
}



// WEBPACK FOOTER //
// ./src/utils/cookie.js